module.exports = __webpack_public_path__ + "img/um.9dd9a2f7.svg";